import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { spacing16, spacing48 } from "@churchofjesuschrist/eden-style-constants";
import { Error, Info, Success, Warn } from "@churchofjesuschrist/eden-alert";
import { mediaBreak840w } from "@churchofjesuschrist/eden-styled-helpers";
import Body from "./components/Body";
const transitionTime = 250;
const Positioned = styled.div.withConfig({
  componentId: "sc-38cjoi-0"
})(["pointer-events:none;position:fixed;z-index:1;bottom:", ";left:0;width:100%;display:flex;justify-content:center;transition:", "ms ease-in-out;transform:", ";&:hover{transform:translate3d(0,0,0);}&:focus-within{transform:translate3d(0,0,0);}", ";"], spacing16, transitionTime, props => props.show ? `translate3d(0, 0, 0)` : `translate3d(0, calc(100% + ${spacing16}), 0)`, mediaBreak840w`
    justify-content: flex-end;
    bottom: ${spacing48};
    transform: ${props => props.show ? `translate3d(0, 0, 0)` : `translate3d(0, calc(100% + ${spacing48}), 0)`};
    
  `);

const Snackbar = _ref => {
  let {
    alertType,
    children,
    action,
    onClose = () => {}
  } = _ref;
  const [show, setShow] = useState(false);
  useEffect(() => {
    setShow(true);
  }, []);
  useEffect(() => {
    const timer = setTimeout(() => {
      setShow(false);
      setTimeout(() => {
        onClose();
      }, transitionTime);
    }, 6000);
    return () => {
      clearTimeout(timer);
    };
  }, [onClose]);

  const selectAlert = type => {
    switch (type) {
      case "error":
        return /*#__PURE__*/React.createElement(Error, null, /*#__PURE__*/React.createElement(Body, {
          action: action
        }, children));

      case "info":
        return /*#__PURE__*/React.createElement(Info, null, /*#__PURE__*/React.createElement(Body, {
          action: action
        }, children));

      case "success":
        return /*#__PURE__*/React.createElement(Success, null, /*#__PURE__*/React.createElement(Body, {
          action: action
        }, children));

      case "warn":
        return /*#__PURE__*/React.createElement(Warn, null, /*#__PURE__*/React.createElement(Body, {
          action: action
        }, children));
    }
  };

  return /*#__PURE__*/React.createElement(Positioned, {
    show: show
  }, selectAlert(alertType));
};

Snackbar.propTypes = {
  /** The body text of the snackbar */
  children: PropTypes.node.isRequired,

  /** The type of alert the snackbar will use */
  alertType: PropTypes.oneOf(["error", "info", "success", "warn"]).isRequired,

  /** An action for the user to take */
  action: PropTypes.shape({
    message: PropTypes.string,
    onClick: PropTypes.func
  }),

  /** A handler for when the snackbar closes */
  onClose: PropTypes.func
};
export default Snackbar;